module.exports = __webpack_public_path__ + "img/141.6f9a91aa.jpg";